import { AUDIT_BASE_URL } from "../../utils/ApiUrls";

class AuditUserDashboardService {
  /**
   * Get dashboard statistics for Audit User
   * @param {string} accessToken - JWT access token
   */
  async getDashboardStats(accessToken) {
    try {
      const response = await fetch(`${AUDIT_BASE_URL}/dashboard/audit-user/stats/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch dashboard statistics',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  /**
   * Get recent audit plans for Audit User dashboard
   * @param {string} accessToken - JWT access token
   */
  async getRecentAuditPlans(accessToken) {
    try {
      const response = await fetch(`${AUDIT_BASE_URL}/dashboard/audit-user/recent-audit-plans/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch recent audit plans',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  /**
   * Get recent recommendations for Audit User dashboard
   * @param {string} accessToken - JWT access token
   */
  async getRecentRecommendations(accessToken) {
    try {
      const response = await fetch(`${AUDIT_BASE_URL}/dashboard/audit-user/recent-recommendations/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch recent recommendations',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }
}

const auditUserDashboardService = new AuditUserDashboardService();
export default auditUserDashboardService;
